import React, { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Encabezado } from '../../Components/Encabezado/Encabezado';
import { RegistroSeleccionMenuCombosEmpleado } from '../../Components/Cafetería/Page/RegistroSeleccionMenuCombosEmpleado';
import Loading from '../../Components/Modals/Loading/Loader';

import { 
    Step, 
    StepButton, 
    Stepper
} from '@mui/material';

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { 
  fetchGetSemanaAlmuerzoActiva,
  fetchGetCombosSemanaById,
  fetchSeleccionComboSemanalEmpleado,
  fetchGetDiasAlmuerzo,
  fetchCambiarSuccess,
  fetchValidacionSubsidioComidaEmpleadoAplica,
  selectSemanaAlmuerzoActiva,
  selectDiasAlmuerzo,
  selectIsLoading,
  selectIsSuccess, 
  selectMessage,
  selectCombosSemanaById,
  selectSeleccionCombosSemanalEmpleado,
  selectValidacionSubsidioComidaEmpleadoAplica
} from '../../redux/Cafeteria/CafeteriaSlice';

import { selectUserData } from '../../redux/Login/LoginSlice';

import swal from 'sweetalert';
import { removeAccents } from '../../utils';

export const DigitarMenuComboEmpleado = () => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const semana = useSelector(selectSemanaAlmuerzoActiva);
    const diasSemanas = useSelector(selectDiasAlmuerzo);
    const isLoading = useSelector(selectIsLoading);
    const combosSemanaById = useSelector(selectCombosSemanaById);
    const seleccionCombosSemanaEmpleado = useSelector(selectSeleccionCombosSemanalEmpleado);
    const { Id : usuarioId} = useSelector(selectUserData);
    const success = useSelector(selectIsSuccess);
    const message = useSelector(selectMessage);
    const usuarioAplicaSubsidio = useSelector(selectValidacionSubsidioComidaEmpleadoAplica);

    // * VALIDACIONES DEL HOOK-FORM PARA LAS CONTRASEÑAAS.
    const formSchema = Yup.object().shape({
        combosEmpleado: Yup.object().shape({
            lunes: Yup.object(),
            martes: Yup.object(),
            miercoles: Yup.object(),
            jueves: Yup.object(),
            viernes: Yup.object(),        
        }),
    });

    // ? HOOK-FORM
    const form = useForm({
        defaultValues: {
            combosEmpleado: {
                lunes: {},
                martes: {},
                miercoles: {},
                jueves: {},
                viernes: {}
            },
        },
        resolver: yupResolver(formSchema)
    })

    // * DESESTRUCTURACION DEL HOOK-FORM
    const { control, setValue } = form;

    // ? HOOK-WATCH
    const combosWatch = useWatch({
        control,
        name: "combosEmpleado",
    })

    // ? HOOK-STATE PARA LA PAGINACION DE PAGINAS.
    const [stepPosition, setStepPosition] = useState({position: 0, diaId: 1}); 

    // ? HOOK STATE PARA ALMACENAR LOS DIAS DE LUNES A VIERNES Y ADICIONAL EL RESUMEN DEL MENU SEMANAL.
    const [diasSemanaState, setDiasSemanaState] = useState([]);

    // * FUNCION QUE REFRESCA TODAS LAS LISTAS.
    const refreshAll = () => {
        dispatch(fetchGetSemanaAlmuerzoActiva());
        dispatch(fetchGetDiasAlmuerzo())
    }

    // ? HOOK-EFFECT
    useEffect(() => {
        refreshAll()
        dispatch(fetchValidacionSubsidioComidaEmpleadoAplica({empleadoId: usuarioId}));
    }, [])

    // ? HOOK-STATE PARA AÑADIR UN NUEVO DIA DE SEMANA QUE ES EL RESUMEN DE LA SELECCION.
    useEffect(() => {
        setDiasSemanaState([...diasSemanas, { id: 6, descripcion: "RESUMEN DE LA SELECCIÓN"}]);
    }, [diasSemanas])

    useEffect(() => {
      if(Object.keys(semana).length > 0){
        dispatch(fetchGetCombosSemanaById({semanaId: semana.id, enabledComboNoAplica: true}));
        dispatch(fetchSeleccionComboSemanalEmpleado({empleadoId: usuarioId, semanaId: semana.id}));
      }
    }, [semana])

    // ? HOOK-EFFECT PARA VALIDAR LA EXISTENCIA DE SELECCION DE COMBOS POR PARTE DEL USUARIO
    useEffect(() => {
      if(seleccionCombosSemanaEmpleado.length > 0){

        // * VARIABLE DONDE SE CREARA EL COMBO DEL EMPLEADO POR DEFECTO.
        let combosEmpleado = {};

        for (let i = 0; i < seleccionCombosSemanaEmpleado.length; i++) {
            
            // * DESESTRUCTURACION DE DATOS.
            const { combos, descripcion: dia } = seleccionCombosSemanaEmpleado[i];

            // * DIA NORMALIZADO
            const diaNormalized = removeAccents(dia).toLocaleLowerCase();

            if(combos.length > 0){
                combosEmpleado = {...combosEmpleado, [diaNormalized]: combos[0]}
            }
            
        }

        setValue('combosEmpleado', combosEmpleado);
      }
    }, [seleccionCombosSemanaEmpleado])

    // ? HOOK-EFFECT PARA SWEET-ALERT
    useEffect(() => {

        if (success === "success" && message.length > 0) {
            swal("Exitoso!", message, "success", {
                timer: 1200,
            });

            // * RESET STATE.
            setStepPosition({position: 0, diaId: 1});
            dispatch(fetchCambiarSuccess());
            
            // * REFRESCAR TODAS LAS LISTAS NUEVAMENTE.
            refreshAll();
            dispatch(fetchSeleccionComboSemanalEmpleado({empleadoId: usuarioId, semanaId: semana.id}));
        } 
        else if (success === "error") {
            swal("Error", message, "error", {
                timer: 5000
            });

            dispatch(fetchCambiarSuccess());
        }
    }, [success]);

    // * COMPONENTE PARA ACTUALIZAR LA PAGINA SEGUN EL DIA ELEGIDO.
    const HandleSteps = ({ stepPosition: { diaId } }) => {

        let children = <></>;

        const comboFilterDay = combosSemanaById.find(x => x.id === diaId) ?? [];

        children = 
        <RegistroSeleccionMenuCombosEmpleado
        stepPosition={stepPosition}
        setStepPosition={setStepPosition}
        diasSemanas={diasSemanas} 
        comboFilterDay={comboFilterDay}
        combosWatch={combosWatch}
        form={form}
        usuarioId={usuarioId}
        semanaId={semana?.id}
        semana={semana}
        usuarioAplicaSubsidio={usuarioAplicaSubsidio}
        />     

        return children;
    };

  return (
    <Encabezado title={`Menú de Almuerzo - ${semana.semanaLabel}`}>
        <Stepper alternativeLabel activeStep={seleccionCombosSemanaEmpleado.length > 0 ? 6 : stepPosition.position} sx={{ marginTop: 2 }}>
                    
            {
                diasSemanaState.length > 0 &&
                    diasSemanaState.map((item, index) =>

                        <Step key={index}>
                            <StepButton disabled={!usuarioAplicaSubsidio}  onClick={() => setStepPosition({position: index, diaId: item.id})}>
                                {item.descripcion}
                            </StepButton>
                        </Step>
                    )
            }

        </Stepper>

        <div style={{ marginTop: '3%' }}>
            <HandleSteps stepPosition={stepPosition} />
        </div>

        <Loading open={isLoading} />
    </Encabezado>
  )
}
